import Modules from './self-serve/modules/'
import initModules from './modules/ModulesInitializer'
import { SearchBar, Header, MainNav, CookieWidget, GtmEvents } from './core'
import * as SelfServeCore from './self-serve/core'
import * as Validation from './core/validation'
import { FeatureDetection } from './utils/'
import LogRocket from 'logrocket'

const initSite = () => {
  SearchBar.init()
  Header.init()
  MainNav.init()
  CookieWidget.init()
  initModules(Modules)

  SelfServeCore.FormOnSubmitClickCatcher.init()
  SelfServeCore.GtmTracking.init()

  Validation.RequiredIf.init()

  FeatureDetection.getCssClasses().forEach(classname => document.body.classList.add(classname.cssClass))
  // must run last in order
  GtmEvents.init()
  // start logrocket
  LogRocket.init(`paymentsense/paymentsense-marketing-${psLogRocketEnvironment}`)

  if (window.isQuotePage) {
    SelfServeCore.LogRocketTracking.initQuoteFormTracking()
  }
}

// Initialise all modules found on a given page
// Alternative to peppering the site with difficult to manage script blocks
document.addEventListener('DOMContentLoaded', initSite)



// WEBPACK FOOTER //
// ./js/Affiliate.js